import { ChangeDetectorRef, ElementRef, EventEmitter, OnDestroy, OnInit, } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Margin } from '@freelancer/ui/margin';
import { FontColor, FontSize } from '@freelancer/ui/text';
import { startWith } from 'rxjs/operators';
import { SatDatepicker } from 'saturn-datepicker';
import { HoverColor, IconColor, IconSize } from '../icon/icon.component';
import { LocalizedDateFns } from '../localized-date-fns.service';
export var InputType;
(function (InputType) {
    InputType["DATE"] = "date";
    InputType["DATERANGE"] = "daterange";
    InputType["EMAIL"] = "email";
    InputType["NUMBER"] = "number";
    InputType["PASSWORD"] = "password";
    InputType["SEARCH"] = "search";
    InputType["TEXT"] = "text";
})(InputType || (InputType = {}));
export var InputSize;
(function (InputSize) {
    InputSize["SMALL"] = "small";
    InputSize["MID"] = "mid";
    InputSize["LARGE"] = "large";
    InputSize["XLARGE"] = "xlarge";
    InputSize["XXLARGE"] = "xxlarge";
})(InputSize || (InputSize = {}));
export var InputBackgroundColor;
(function (InputBackgroundColor) {
    InputBackgroundColor["DARK"] = "dark";
    InputBackgroundColor["LIGHT"] = "light";
})(InputBackgroundColor || (InputBackgroundColor = {}));
export var InputTextAlign;
(function (InputTextAlign) {
    InputTextAlign["LEFT"] = "light";
    InputTextAlign["RIGHT"] = "right";
})(InputTextAlign || (InputTextAlign = {}));
var InputComponent = /** @class */ (function () {
    function InputComponent(cd, datefns) {
        this.cd = cd;
        this.datefns = datefns;
        this.Margin = Margin;
        this.FontColor = FontColor;
        this.FontSize = FontSize;
        this.HoverColor = HoverColor;
        this.InputBackgroundColor = InputBackgroundColor;
        this.InputType = InputType;
        this.inputFocused = false;
        this.iconStartClickable = false;
        this.iconEndClickable = false;
        this.expanded = false;
        this.size = InputSize.MID;
        // Not for general use. This is only for search.
        // If you'd like to use this input, make sure you discuss with UI Eng
        this.isExpandable = false;
        this.type = InputType.TEXT;
        this.backgroundColor = InputBackgroundColor.LIGHT;
        this.leftIconSize = IconSize.MID;
        this.leftIconColor = IconColor.INHERIT;
        this.rightIconSize = IconSize.MID;
        this.rightIconColor = IconColor.INHERIT;
        this.beforeLabel = '';
        this.afterLabel = '';
        this.textAlign = InputTextAlign.LEFT;
        this.iconStartClick = new EventEmitter();
        this.iconEndClick = new EventEmitter();
    }
    Object.defineProperty(InputComponent.prototype, "disabled", {
        set: function (value) {
            this.attrDisabled = value ? true : undefined;
            if (this.isDateInput()) {
                this.iconEndClickable = !value;
            }
        },
        enumerable: true,
        configurable: true
    });
    InputComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.dateFormat = this.datefns.dateFormat;
        this.dateRangeFormat = this.datefns.dateRangeFormat;
        this.errorSubscription = this.control.statusChanges
            .pipe(startWith(this.control.status))
            .subscribe(function () {
            if ((_this.type === InputType.DATE || _this.type === InputType.DATERANGE) &&
                _this.isMatDatePickerError(_this.control.errors)) {
                // Material's datepicker doesn't expose a nice error string like the
                // native form controls, so use our own
                _this.error = 'Please select a valid date.';
            }
            else {
                _this.error = Object.values(_this.control.errors || {})[0];
            }
            _this.cd.markForCheck();
        });
        // We are able to check for subscriptions to these inputs in order to infer
        // whether or not the icons should be clickable (displayed as buttons)
        this.iconStartClickable = this.iconStartClick.observers.length > 0;
        this.iconEndClickable = this.iconEndClick.observers.length > 0;
        if (this.isDateInput()) {
            // force a calendar picker icon
            this.iconEnd = 'ui-calendar';
            this.iconEndClickable = !this.attrDisabled;
        }
    };
    InputComponent.prototype.ngOnDestroy = function () {
        this.errorSubscription.unsubscribe();
    };
    InputComponent.prototype.isDateInput = function () {
        return this.type === InputType.DATE || this.type === InputType.DATERANGE;
    };
    InputComponent.prototype.handleIconEndClick = function (e) {
        if (this.type === InputType.DATE || this.type === InputType.DATERANGE) {
            // open the matDatePicker instead of emitting
            // it automatically closes when you click outside
            this.satDatepicker.open();
            return;
        }
        this.iconEndClick.emit(e);
    };
    InputComponent.prototype.handleIconStartClick = function (e) {
        this.iconStartClick.emit(e);
    };
    // Hack around Material's error format
    InputComponent.prototype.isMatDatePickerError = function (errors) {
        return errors && errors.matDatepickerParse;
    };
    return InputComponent;
}());
export { InputComponent };
